import { FC } from 'react'
import styled from 'styled-components'
import LeftSection from './LeftSection'
import RightSection from './RightSection'
import SelectedCategories from './SelectedCategories'

interface IFJobCategoryBottomSheetMidProps {
  className?: string
}

const JobCategoryBottomSheetMid: FC<IFJobCategoryBottomSheetMidProps> = ({
  className,
}) => {
  return (
    <StyledWrapper className={className}>
      <LeftSection className="lt-section" />
      <RightSection className="rt-section" />
      <SelectedCategories className="selected-categories" />
    </StyledWrapper>
  )
}

export default JobCategoryBottomSheetMid

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  height: 45vh;
  :has(.selected-categories > div) {
    padding-bottom: 50px;
  }
  .lt-section {
    flex: 2;
  }

  .rt-section {
    flex: 3;
  }

  .selected-categories {
    position: absolute;
    bottom: 0;
  }
`
